import React, { forwardRef } from 'react';

import { CheckboxProps } from './types';
import { Mark, Input, Wrapper } from './style';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checkboxSize = 'medium', color = 'primary_400', colorActive = 'primary_400', ...props }, ref) => (
    <Wrapper>
      <Input data-size={checkboxSize} data-color={color} data-coloractive={colorActive} {...props} type="checkbox" />
      <Mark />
    </Wrapper>
  )
);

export default Checkbox;
